import Request from './request'

const TelegramNotifications = {
  getTelegramDestinations (params, callback) {
    return Request.get('telegram-destination/index?' + new URLSearchParams(params).toString()).then(callback).catch(this.bad_answer)
  },
  createTelegramDestination (params, callback) {
    return Request.post('telegram-destination/create', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  disableTelegramDestination (id, callback) {
    return Request.post('telegram-destination/disable/' + id).then(callback).catch(this.bad_answer)
  },
  testTelegramDestination (id, callback) {
    return Request.post('telegram-destination/test/' + id).then(callback).catch(this.bad_answer)
  },
  getNotificationRouteCatalog (callback) {
    return Request.get('notification-route/catalog').then(callback).catch(this.bad_answer)
  },
  getNotificationRoutes (params, callback) {
    return Request.get('notification-route/index?' + new URLSearchParams(params).toString()).then(callback).catch(this.bad_answer)
  },
}
export default TelegramNotifications
